import { createContext } from "react";

export const BuildsContext = createContext({});